import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Instructor } from 'src/app/model/instructor.model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { InstructorStatus } from 'src/app/model/instructor-status.model';
import { InstructorService } from 'src/app/service/instructor.service';
import { DataService } from 'src/app/service/data.service';
import { User } from 'src/app/model/user.model';

@Component({
  selector: 'app-instructor-edit',
  templateUrl: './instructor-edit.component.html',
  styleUrls: ['./instructor-edit.component.css']
})
export class InstructorEditComponent implements OnInit {
  instructor: Instructor;
  instructorEditForm: FormGroup;
  instructorStatus: InstructorStatus[];
  selectedStatus: InstructorStatus;
  title = 'Edit instructor';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private isntructorService: InstructorService,
    private dataService: DataService) {}

  ngOnInit() {
    this.dataService.getinstructorStatus().subscribe(data=>{
      this.instructorStatus=data as InstructorStatus[];
      this.activatedRoute.params.subscribe(params => {
        const id = params.id;
        if ( id > 0) {
          this.isntructorService.getById(id).subscribe(data => {
            this.instructor = data as Instructor;
            this.selectedStatus = this.instructor.status;
            this.initInstructorEditForm();
          });
        } else {
          this.title = 'Add instructor';
          this.instructor = new Instructor(new User(), [], this.instructorStatus[0], [], []);
          this.selectedStatus =  this.instructorStatus.find(x => x.id === this.instructor.status.id);
          this.initInstructorEditForm();
        }

      });
    })

  }

  initInstructorEditForm() {
    this.instructorEditForm = this.formBuilder.group({
      firstName: new FormControl(this.instructor.user.name),
      lastName: new FormControl(this.instructor.user.lastName),
      phone: new FormControl(this.instructor.user.phone),
      email: new FormControl(this.instructor.user.email)
    });
  }

  setStatus(filterVal: any) {
    this.instructor.status = filterVal as InstructorStatus;
  }

  save() {
    if (this.instructor.user.id > 0) {
      this.isntructorService.edit(this.instructor).subscribe(data => {
        if (data) {
          this.router.navigateByUrl(`/instructor-list`);
        }
      });
    } else {
      this.isntructorService.add(this.instructor).subscribe(data => {
        if (data) {
          this.router.navigateByUrl(`/instructor-list`);
        }
      });
    }
  }

  delete() {
    this.isntructorService.delete(this.instructor.user.id).subscribe(data => {
      if (data) {
        this.router.navigateByUrl(`/instructor-list`);
      }
    });
  }

  cancel() {
    this.router.navigateByUrl(`/instructor-list`);
  }
}
